module.exports = {
  breakpoints: {
    // values in px
    smallPhone: 320,
    phone: 375,
    phoneLarge: 414,
    tablet: 768,
    tabletLandscape: 1024,
    content: 1200,
    desktop: 1440,
  },
  mediaExpressions: {
    // use with window.matchMedia(<query>)
    screen: '"screen"',
    print: '"print"',
    handheld: '"handheld"',
    landscape: '"(orientation: landscape)"',
    portrait: '"(orientation: portrait)"',
    retina2x: '"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)"',
    retina3x: '"(-webkit-min-device-pixel-ratio: 3), (min-resolution: 350dpi)"',
    ie: '"(-ms-high-contrast:none), (-ms-high-contrast: active)"',
    canhover: '"(any-hover: hover)"',
    reducedmotion: '"(prefers-reduced-motion)"',
    lightmode: '"(prefers-color-scheme: light)"',
    darkmode: '"(prefers-color-scheme: dark)"',
  },
};
